import { tr } from "date-fns/locale";
import { getCountryNameByCountryCode } from "../../../../../utils/utility";

export default function vendorSelection(config) {
    if (!config.data) return null;

    let result = {};
    let tableData = [];
    const { vendorSelectionData = [], vendorSelectionDataCopy = [], selectedCountryVendor = {} } = config.data;

    vendorSelectionData.map((countryData, index) => {
        const countryCode = countryData.country.countryCode;
        let row = [];
        const rowId = `${config.tableType}|${countryCode}`;

        config.columns.forEach(column => {
            const columnId = column.id;
            const displayAsIs = column.data.displayInBodyAsIs;
            const columnDataType = column.data.displayInBodyAs;
            const highlightColumn = column.data.highlightBodyText;

            let columnValue = 0;
            let columnValueData = null;
            let columnLabelValue = null;
            let isDisabled = false;
            let bgColor = null;
            if (columnDataType === "selectionCheckBox") {
                if (columnId === "country") {
                    columnLabelValue = getCountryNameByCountryCode(countryCode);
                    columnValue = countryData.country.value
                }
                else {
                    const vendorName = columnId.split('-')[1];
                    const vendorValue = countryData.vendors.filter(vendor => vendorName === vendor.vendorName);
                    columnValue = vendorValue.length ? vendorValue[0].value : "";

                    const vendorCopy = vendorSelectionDataCopy[index].vendors.filter(vendor => vendorName === vendor.vendorName)
                    isDisabled = !(vendorCopy.length ? vendorCopy[0].value : false);
                }
            }

            if (columnDataType === "selectionCheckBoxTri") {
                let isVendorSelected = selectedCountryVendor[countryCode] === columnId.split('-')[1] ? true : false;
                if (columnId === "country") {
                    columnLabelValue = getCountryNameByCountryCode(countryCode);
                    columnValue = countryData.country.value
                }
                else {
                    const vendorName = columnId.split('-')[1];
                    const vendorValue = countryData.vendors.filter(vendor => vendorName === vendor.vendorName);
                    columnValue = vendorValue.length ? vendorValue[0].value : "";

                    const vendorCopy = vendorSelectionDataCopy[index].vendors.filter(vendor => vendorName === vendor.vendorName)
                    isDisabled = !(vendorCopy.length ? vendorCopy[0].value : false);
                    bgColor = isVendorSelected ? "#024ad85e" : null;
                }

            }

            row.push({
                [columnId]: {
                    id: columnId + "|" + rowId,
                    columnId: columnId,
                    type: columnDataType,
                    value: columnValueData || columnValue,
                    label: columnLabelValue,
                    width: column.width,
                    displayAsIs: displayAsIs,
                    showInMobileViewAs: column.showInMobileViewAs,
                    highlightColumn: highlightColumn,
                    disabled: isDisabled,
                    bgColor: bgColor,
                    clickHandler: (columnDataType !== "string" && config.bodyButtonsHandler) ? event => config.bodyButtonsHandler(event, countryCode, columnId) : null
                }
            });
        });

        tableData.push({
            id: rowId,
            data: row
        });
    })

    result['columns'] = config.columns;
    result['data'] = tableData;
    ;
    return result;
}